import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const o=t("greece",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M24 4.5L0 4.5L0 20.5L24 20.5L24 4.5Z"
                fill="#005DB5" />
            <path
                d="M24 18.7222L0 18.7222L0 16.9444L24 16.9444V18.7222ZM24 15.1667L0 15.1667L0 13.3889H3.55556L3.55556 9.83333H0L0 8.05556H3.55556L3.55556 4.5H5.33333L5.33333 8.05556L8.88889 8.05556V9.83333L24 9.83333V11.6111L8.88889 11.6111L8.88889 9.83333L5.33333 9.83333L5.33333 13.3889L24 13.3889V15.1667ZM24 8.05556L8.88889 8.05556V6.27778L24 6.27778V8.05556Z"
                fill="white" />
        </svg>
    `),p=t("greece_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19486_135976)">
                <path
                    d="M36 0.5L0 0.5L0 24.5L36 24.5L36 0.5Z"
                    fill="#005DB5" />
                <path
                    d="M36 21.8333L0 21.8333L0 19.1667L36 19.1667V21.8333ZM36 16.5L0 16.5L0 13.8333H5.33333L5.33333 8.5H0L0 5.83333L5.33333 5.83333L5.33333 0.5L8 0.5L8 5.83333L13.3333 5.83333L13.3333 8.5L36 8.5V11.1667L13.3333 11.1667V8.5L8 8.5L8 13.8333L36 13.8333V16.5ZM36 5.83333L13.3333 5.83333V3.16667L36 3.16667V5.83333Z"
                    fill="white" />
            </g>
            <defs>
                <clipPath id="clip0_19486_135976">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Greece,p as GreeceRounded};
